'use client'

import { memo } from 'react'
import { NinkVoiceRibbon } from '@/app/nink/_components/nink-voice-ribbon'
import { NINXL_INKFLOW_DEMO_SRC } from '@/lib/landing-demos'

const MODES = [
  { title: 'Dictate', hotkey: '⇧ Shift' },
  { title: 'Instruct', hotkey: 'Caps Lock' },
  { title: 'Transform', hotkey: 'Chain' },
] as const

/**
 * baby: InkFlow. Whisper ribbon blends into the page; demo stamp sits to the right.
 */
export const CraftInkflow = memo(function CraftInkflow() {
  return (
    <div className="craft-inkflow" data-testid="craft-inkflow">
      <div className="craft-inkflow__intro">
        <p className="craft-section__eyebrow">InkFlow</p>
        <h2 className="craft-section__title">Speak. It writes everywhere.</h2>
        <p className="craft-section__body">
          On-device Whisper turns speech into text at your cursor. Slack, Docs, Mail, or your IDE.
        </p>
        <div className="craft-inkflow__modes" aria-label="InkFlow modes">
          {MODES.map((mode, index) => (
            <span key={mode.title} className="craft-inkflow__mode">
              {index > 0 ? <span className="craft-inkflow__mode-sep" aria-hidden>·</span> : null}
              <span className="craft-inkflow__mode-title">{mode.title}</span>
              <span className="craft-inkflow__mode-hotkey">{mode.hotkey}</span>
            </span>
          ))}
        </div>
      </div>

      <div className="craft-inkflow__band">
        {/* baby: Full-bleed whisper motion: no kraft card chrome. */}
        <div className="craft-inkflow__atmosphere" aria-label="Whisper on-device animation">
          <NinkVoiceRibbon />
        </div>

        {/* baby: Demo stamp on the right: readable size, not a full-bleed video. */}
        <figure className="craft-inkflow__demo">
          <figcaption className="craft-inkflow__demo-label">Demo</figcaption>
          <div className="craft-inkflow__demo-frame">
            <video
              src={NINXL_INKFLOW_DEMO_SRC}
              muted
              playsInline
              autoPlay
              loop
              preload="metadata"
              aria-label="InkFlow demo"
            />
          </div>
        </figure>
      </div>
    </div>
  )
})

CraftInkflow.displayName = 'CraftInkflow'
